import { ApiTypes } from "types"
import { StorageKeys } from "types/enums/StorageKeys"

import { getStorageItem, setStorageItem } from "./localStorage"

const updateStorageUser = (userProps: Partial<ApiTypes.Model.UserProfile>) => {
  const userProfile = getStorageItem(StorageKeys.UserProfile)
  if (userProfile && typeof userProfile === "object") {
    setStorageItem(StorageKeys.UserProfile, { ...userProfile, ...userProps })
  }
}

export default updateStorageUser
